// removed by extract-text-webpack-plugin
module.exports = {"storeCard":"_2j5Ma","backgroundPhoto":"_2pxyb","hoverOverlay":"_3AENF","details":"ykzfG","name":"_1ccQv","marketingMessage":"_2RZEN","location":"v7Qsr"};


//////////////////
// WEBPACK FOOTER
// ./banquet/components/StoreCard/index.sass
// module id = 1510
// module chunks = 1